import React, { useState, useEffect } from "react";
import BiodataRegister from "../../components/step/register/biodata-register.component";
import ProfileRegister from "../../components/step/register/profile-register.component";
import RoleRegister from "../../components/step/register/role-register.component";
import Step from "../../components/step/step.component";
import image from "../../assets/images/register-bg.jpg";
import RuumiesLogo from "../../assets/images/ruumies-white-logo.svg";
// import { useNavigate } from "react-router-dom";
import CompletedRegister from "../../components/step/register/completed-register.component";
import logo from "../../assets/images/logoimg.png";

export default function CompleteAccountScreen() {
  const [currentStep, setCurrentStep] = useState(2);
  // const navigator = useNavigate();

  useEffect(() => {
    document.title = "Complete account setup - Ruumies";
  }, []);

  return (
    <div className="h-screen w-screen flex">
      <div
        className="hidden md:inline-block md:w-1/3 h-full bg-cover bg-top"
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className="h-full flex flex-col justify-between px-6 py-10">
          <img src={RuumiesLogo} alt="Ruumies Logo" width={110} height={23} />
          <div className="flex flex-col">
            <h4 className="text-white text-[48px] font-medium">
              Get the right ruummate in few clicks
            </h4>
            <p className="text-white text-[20px] text-opacity-80 font-bold">
              Simplified for easy access to a teeming backlog of users.
            </p>
          </div>
        </div>
      </div>
      <div className="inline-block w-full md:w-2/3 h-full pt-10 overflow-auto">
        <div className="p-5 pt-0 lg:w-[550px] md:w-2/3 mx-auto pb-10">
          <div className="w-full flex flex-col justify-center">
            <div className="mb-8 flex items-center justify-center">
              <img src={logo} alt="logo" width="110" height="23" />
            </div>
            
            <Step numberOfStep={5} currentStep={currentStep} />

            {currentStep === 2 && (
              <BiodataRegister onCompleted={() => setCurrentStep(currentStep + 1)} />
            )}
            
            {currentStep === 3 && (
              <ProfileRegister onCompleted={() => setCurrentStep(currentStep + 1)} />
            )}
            
            {currentStep === 4 && (
              <RoleRegister
                onCompleted={() => setCurrentStep(currentStep + 1)}
              />
            )}
            
            {currentStep === 5 && (
              <div className="w-full">
                <CompletedRegister />
                {/* <button 
                  onClick={() => navigator("/dashboard")}
                  className="w-full bg-primary text-white py-3 px-4 rounded-md hover:bg-opacity-90 transition font-medium mt-6"
                >
                  Go to Dashboard
                </button> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}